import React from "react";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

const withStyledSystem = (Component) => (props) =>
  (
    <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
      <Component {...props} />
    </StyleSheetManager>
  );

export default withStyledSystem;
